<template>
  <div class="order-line-card">
    <el-card>
      <div class="chartBox"  ref="orderLineBox"></div>
    </el-card>
  </div>
</template>

<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
export default {
  name: "OrderLineCard",
  components: {},
  props: {
  },
  watch: {
  },
  data() {
    return {
      orderLineChart: null,
      orderLineHeader: [],
      orderLineData: []
    };
  },
  computed: {
  },
  methods: {
    getOrderLineData () {
      this.$nextTick(() => {
        this.$axios.get('/api/admin/data_overview/order_line_data', { loadingClose: true })
          .then((res) => {
            const { data } = res
            if (data.code === 0) {
              console.log(data)
              this.orderLineHeader = data.data.map(item => item.day)
              this.orderLineData = data.data.map(item => item.total_sum)
              this.initCharts()
            }
          })
      })
    },
    initCharts () {
      this.$nextTick(() => {
        this.orderLineChart = echarts.init(this.$refs.orderLineBox, 'light')
        this.setOrderLineChart()
      })
    },
    setOrderLineChart () {
      let option = {
        title: {
          text: '日业绩变化趋势图'
        },
        toolbox: {
          show: true,
          showTitle: true,
          feature: {
            saveAsImage: {
              show: true,
              title: '下载'
            },
            magicType: {
              show: true,
              type: ['line', 'bar']
            }
          }
        },
        xAxis: {
          boundaryGap: false,
          type: 'category',
          data: this.orderLineHeader
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: this.orderLineData,
            type: 'line',
            areaStyle: {},
            smooth: true,
            itemStyle: {
              normal: {
                areaStyle: {
                  type: 'default',
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#5787FF'
                    },
                    {
                      offset: 0.5,
                      color: '#98B7FF'
                    },
                    {
                      offset: 1,
                      color: '#DEEBFF'
                    }
                  ])
                },
                lineStyle: {
                  color: '#5B88EE'
                }
              }
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        }
      }
      this.orderLineChart.setOption(option)
    }
  },
  mounted() {
    this.getOrderLineData()
  },
};
</script>

<style lang="stylus" scoped>
.chartBox {
  width: 100%;
  height: 6rem;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/data_overview/common/OrderLineCard.vue